import type { ActionTree } from 'vuex'
import type { PromoterTasksState } from './types'
import type { RootState } from '@/store/modules/types'

// Actions are now deprecated - polling is handled by useTaskPolling composable
// kept for backwards compatibility but they're no-ops
export const promoterTasksActions: ActionTree<PromoterTasksState, RootState> = {
  // Deprecated: Polling is now managed by useTaskPolling composable + polling-gate plugin
  async START_POLLING_PENDING_TASKS() {
    // No-op: polling is auto-started by polling-gate.client.ts plugin
  },
  // Deprecated: Polling is now managed by useTaskPolling composable + polling-gate plugin
  STOP_POLLING_PENDING_TASKS() {
    // No-op: polling is auto-managed by tab visibility
  },
}
